import api from '../../api/api.js'
import mygoods from '../../api/moudles/mygoods.js'
import userStoreItems from '../../api/moudles/userStoreItems.js'
import utils from '../../utils/utils.js'
import { Message } from 'element-ui'

import {
  SET_MYGOODS_LIST,
  GET_MYGOODS_TOTAL,
  ADD_STORE_ITEMS,
  GET_SUCCESS_DATA,
  GET_ERROR_DATA,
  GET_CURCODE_LIST ,
  GET_CURCODE_LIST_NULL,
  SET_SUCCESS_ERROR_NULL,
  KEEP_CHOOSED_ITEM,
  SET_ITEM_TRUE
} from '../mutation-types'
import { resolve } from 'path'

const state = () => ({
  mygoodslist:[],
  goodsTotal:0,
  successtotal:0,
  succesList:[],
  errorList:[],
  curCodeList:[],
  lazadaitems:[],
  lazadaCount:0,
  salesInfo:[],
  intentoryturnover:0,
  ischooselist:[],
  cateGoryList:[],
  cateGoryListCopy:[],
  already:false,
  bindSuccess:[],
  bindError:[],
  openDia:false
  

  
})

const getters = {}

const actions = {
	//匹配sku绑定仓库商品
	bindBYsku({state},payload){
		mygoods
		.bindBYsku(payload)
		.then(res => {
			if(res.code === 200 ){
				console.log('匹配sku绑定仓库商品',res.data)
				state.openDia=true
				state.bindSuccess=res.data.succcessItems
				state.bindError=res.data.errorItems
				console.log(state.openDia)
				
			}
		})
	},
	//批量生成仓库产品
	batchCreateStoreItem({state},payload){
		mygoods
		.batchCreateStoreItem(payload)
		.then(res => {
			if(res.code === 200 ){
				console.log('批量生成仓库产品',res.data)
				
				Message({
					message: '成功批量生成仓库产品！',
					type: 'success'
				})
				state.already=true
				setTimeout(() => {
					state.already=false
				},500)
			}
		})
	},

	getCategoryByshop({state},payload){
		const p=new Promise((resolve) => {
			mygoods
			.getCategoryByshop(payload)
			.then(res => {
				if(res.code === 200 || res.code === 500){
					console.log('获取商店商品的所有类目信息',res.data)
					
					state.cateGoryList=res.data == undefined ? [] :res.data
					let shopList=[{
						value:payload.shopId,
						hasChildren:true,
						label:utils.showshopNameByshopIdOne(payload.shopId),
					}]
					// let  list=state.cateGoryList.map(p => {
					// 	return {
					// 		value:p.categoryId,
					// 		label:p.categoryName,
					// 		parentId:p.parentId,
					// 		children:p.childrens.map(k => {
					// 			return{
					// 				value:k.categoryId,
					// 				label:k.categoryName,
					// 				parentId:k.parentId,
					// 				children:k.childrens.map(i => {
					// 					return {
					// 						value:i.categoryId,
					// 						label:i.categoryName,
					// 						parentId:i.parentId,
					// 						hasChildren:i.hasChildren
					// 					}
					// 				}),
					// 				hasChildren:k.hasChildren
					// 			}
					// 		}),
					// 		hasChildren:p.hasChildren
							
					// 	}
					// })
					shopList[0].children=[]
					shopList.forEach(p => {
						state.cateGoryListCopy.push(p)
					})
					resolve('success')
					console.log('cateGoryListCopy',state.cateGoryListCopy)
				}
			})
		})

		return p
	},

	//获取库存周转率
	getInventoryTurnover({state},payload){
		mygoods
		.getInventoryTurnover(payload)
		.then(res => {
			if(res.code === 200 ){
				console.log('库存周转率',res.data)
				state.intentoryturnover=res.data.toFixed(2)
			}
		})
	},
	// 获取商品销售情况
	getItemSales({state},payload){
		mygoods
		.getItemSales(payload)
		.then(res => {
			if(res.code === 200 ){
				console.log('商品销售情况',res.data)
				state.salesInfo=res.data
			}
		})
	},
	
	getLazadaWarehouseitems({state},payload){
		mygoods
		.getLazadaWarehouseitems(payload)
		.then(res => {
			if(res.code === 200 ){
				console.log('lazada商店商品信息',res.data)
				state.lazadaitems=res.data.items
				state.lazadaCount=res.data.count
			}
		})
	},
	getOnlineProduct({state},payload){
		mygoods
		.getOnlineGoods(payload)
		.then(res => {
			if(res.code === 200 ){
				console.log('lazada商店商品信息',res.data)
				state.lazadaitems=res.data.items
				state.lazadaCount=res.data.count
			}
		})
	},
	getShopAllItems({commit},payload) {
		mygoods
		.getShopAllItems(payload)
		.then(res => {
			if(res.code ===200) {
				commit(SET_MYGOODS_LIST, res.data)
				
			}else{
				let arr={items:[]}
				commit(SET_MYGOODS_LIST, arr)

			}
		})
	},
	createPurchaseOrder({commit},payload) {
		api
		.createPurchaseOrder(payload)
		.then(res => {
			if(res.code ===200) {
				console.log(res.data)
			}
		})
	},

	addGoodsInStore({commit},payload){
		mygoods
		.addGoodsInStore(payload) 
		.then(res => {
			if(res.code === 200) {
				let newArr =res.data
				console.log('添加商品入仓库',res.data)
				// commit(ADD_STORE_ITEMS,res.data)
				if(res.data.successItem.length) {
					console.log("成功加入仓库",res.data.successItem)
					commit(GET_SUCCESS_DATA,res.data.successItem)
				}
				if(res.data.errorItem.length){
					console.log("重复加入仓库",res.data.errorItem)
					commit(GET_ERROR_DATA,res.data.errorItem)
				}
			}
		})
		
	},

	addNotProductInStore({commit},payload){
		mygoods
		.addNotProductInStore(payload) 
		.then(res => {
			if(res.code === 200) {
				let newArr =res.data
				console.log('添加商品入仓库',res.data)
				// commit(ADD_STORE_ITEMS,res.data)
				if(res.data.successItem.length) {
					console.log("成功加入仓库",res.data.successItem)
					commit(GET_SUCCESS_DATA,res.data.successItem)
				}
				if(res.data.errorItem.length){
					console.log("重复加入仓库",res.data.errorItem)
					commit(GET_ERROR_DATA,res.data.errorItem)
				}
			}
		})
		
	},
	getBindInfo({commit},payload) {
		userStoreItems
		.getStoreItem(payload) 
		.then(res => {
			if(res.code === 200) {
				console.log('CusCode',res.data)
				commit(GET_CURCODE_LIST,res.data)
			}
		})
	},
	
	getBindInfo01({commit},payload) {
		userStoreItems
		.getStoreItem01(payload) 
		.then(res => {
			if(res.code === 200) {
				console.log('CusCode',res.data)
				commit(GET_CURCODE_LIST,res.data)
			}
		})
	},
	
	tongBuShopee({commit},payload){
		const p =new Promise((resolve) => {
			mygoods
			.tongBuShopee(payload) 
			.then(res => {
				resolve(res)
				if(res.code === 200) {
					console.log('成功同步shopee产品')
				}
			})
			
		})

		return p
		
	},
	
	tongBuLazada({commit},payload){
		mygoods
		.tongBuLazada(payload) 
		.then(res => {
			if(res.code === 200) {
				console.log('成功同步lazada产品')
			}
		})
		
	},
	
	

	
	
}

const mutations = {
	[SET_MYGOODS_LIST]: (state,data) =>{
		console.log('选中要加入仓库的商品',state.ischooselist)
		console.log(data.items)
		
			data.items.forEach(item => {
				item.checked=false
				item.checked02=false
				item.isSingle=0
					if(item.variations) {
						item.variations.forEach(p => {
							p.checked=false
							p.isSingle=0
						})
					}
				// if(state.ischooselist.length) {
				// 		state.ischooselist.forEach(p => {
				// 			console.log(p)
				// 			if(p.itemId === item.itemId ){
				// 				console.log(11)
				// 				item.checked=false
				// 				k.isSingle=null
				// 			}
				// 			if(item.hasVariation){
				// 				item.variations.forEach(k => {
				// 					if(k.itemId ==p.variation.itemId && k.variationId == p.variation.variationId) {
				// 						k.checked=false
				// 						k.isSingle=null
				// 					}
				// 				})
				// 			}
				// 		})
				// }
				
			})
			
			console.log(data)
			state.mygoodslist=data.items
			state.goodsTotal=data.count

		

	
		
	},
	[GET_MYGOODS_TOTAL]: (state,data) =>{
		state.goodsTotal=data
	},
	[ADD_STORE_ITEMS]: (state,data) => {
		state.successtotal=data
	},
	[GET_SUCCESS_DATA]:(state,data) => {
		state.succesList=data
	},
	[GET_ERROR_DATA]:(state,data) => {
		state.errorList=data
	},
	[GET_CURCODE_LIST]:(state,data) => {
		state.curCodeList.push(data)
	},
	[GET_CURCODE_LIST_NULL]:(state,data) => {
		state.curCodeList=[]
	},
	[SET_SUCCESS_ERROR_NULL]:(state) => {
		state.errorList=[]
		state.succesList=[]
		state.intentoryturnover=0
		state.cateGoryList=[]
		state.cateGoryListCopy=[]
		state.mygoodslist=[]
		console.log('524',state.cateGoryListCopy)
	},
	//保存选中的货品
	[KEEP_CHOOSED_ITEM]:(state,data) => {
		state.ischooselist=data
	},
	[SET_ITEM_TRUE]:(state,data) => {
		state.mygoodslist.forEach(p => {
			if(p.itemSku == data.itemSku){
				p.checked=data.checked
			}
		})
	},
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}